import { render, staticRenderFns } from "./duo_code_review_system_note.vue?vue&type=template&id=623994d4"
import script from "./duo_code_review_system_note.vue?vue&type=script&lang=js"
export * from "./duo_code_review_system_note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports